module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FormInputs.EyeDoctorInformation),
      expression: "FormInputs.EyeDoctorInformation"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Eye Doctor Information\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "margin": "10px 0px"
    }
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.Account.NoEyeDoctor = !_vm.Account.NoEyeDoctor
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("I do not have an eye doctor to add at this time")])]), _vm._v(" "), (!_vm.Account.NoEyeDoctor) ? _c('p', [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.FormInputs.BusinessLabels) ? _c('p', [_vm._v("\n            Please list the information for at least one eye doctor. You can add more later under My Account page.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('p', [_vm._v("\n            Please list the information for at least one eye doctor you contract with or work with regularly. You can add more later under My Account page.\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Account.EyeDoctors), function(doctor, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("NPI Number\n                                "), (_vm.Account.UseLicenseNumber || (!doctor.UseLicenseNumber && !_vm.Account.NoEyeDoctor)) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
      attrs: {
        "data-balloon": _vm.npiTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.NpiNumber),
        expression: "doctor.NpiNumber"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber
      },
      attrs: {
        "type": "text",
        "maxlength": "10",
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      domProps: {
        "value": (doctor.NpiNumber)
      },
      on: {
        "paste": function($event) {
          return _vm.pasteNpiNumber($event)
        },
        "keyup": function($event) {
          return _vm.ValidateNpiNumberEyeDoctor(index)
        },
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "NpiNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Relationship*\n                                "), _c('span', {
      attrs: {
        "data-balloon": _vm.relationshipTooltip,
        "data-balloon-pos": "down",
        "data-balloon-length": "large"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    })])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.Role),
        expression: "doctor.Role"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorRole))]) : _vm._e()])]), _vm._v(" "), (!doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
    }) : _vm._e(), _vm._v(" "), (doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-8  col-md-8  col-sm-12  col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("License Number\n                                "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.LicenseNumber),
        expression: "doctor.LicenseNumber"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber
      },
      attrs: {
        "maxlength": "18",
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.LicenseNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "LicenseNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLicenseNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (doctor.UseLicenseNumber) ? _c('div', {
      staticClass: "col-lg-4  col-md-4  col-sm-12  col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State\n                                "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.State),
        expression: "doctor.State"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorState
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.State), function(value, key) {
      return _c('option', {
        domProps: {
          "value": value
        }
      }, [_vm._v(_vm._s(value))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorState) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          doctor.UseLicenseNumber = !doctor.UseLicenseNumber
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label"
    }, [_vm._v("Use License Number")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's First Name\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.FirstName),
        expression: "doctor.FirstName"
      }],
      staticClass: "form-control capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.FirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "FirstName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's Last Name\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.LastName),
        expression: "doctor.LastName"
      }],
      staticClass: "form-control capitalize",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0,
        "type": "text"
      },
      domProps: {
        "value": (doctor.LastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "LastName", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Suffix\n                        "), (!_vm.Account.NoEyeDoctor) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.Suffix),
        expression: "doctor.Suffix"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix
      },
      staticStyle: {
        "height": "36.5px"
      },
      attrs: {
        "disabled": _vm.Account.PrimaryContact.IsEyeDoctor && index == 0
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(doctor, "Suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.Suffix), function(value, key) {
      return _c('option', {
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(key))])
    }), 0), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorSuffix))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.EmailAddress),
        expression: "doctor.EmailAddress"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('email'),
        expression: "'email'"
      }],
      staticClass: "form-control",
      class: {
        error_field: _vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress || _vm.errors.has('email')
      },
      attrs: {
        "name": "email",
        "type": "email",
        "data-vv-as": "email",
        "oninput": "this.value = this.value.toLowerCase()"
      },
      domProps: {
        "value": (doctor.EmailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "EmailAddress", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('email') && !_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress),
        expression: "errors.has('email') && !EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), (_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.EyeDoctorValidation[index].validationResult.EyeDoctorEmailAddress))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.Account.PrimaryContact.IsEyeDoctor && index != 0),
        expression: "Account.PrimaryContact.IsEyeDoctor && index != 0"
      }],
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doctor.YearsInPractice),
        expression: "doctor.YearsInPractice"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "4",
        "type": "text"
      },
      domProps: {
        "value": (doctor.YearsInPractice)
      },
      on: {
        "keypress": function($event) {
          return _vm.G_NumberCheck(this.event)
        },
        "keyup": function($event) {
          return _vm.G_NumberOfYearsCheck(doctor, 'YearsInPractice')
        },
        "blur": function($event) {
          return _vm.CheckYearLicense(doctor.YearsInPractice)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(doctor, "YearsInPractice", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errorMessage.year) ? _c('p', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errorMessage.year))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "col-lg-12 offset-lg-5 col-md-12 col-sm-12 col-xs-12"
    }, [(_vm.Account.EyeDoctors.length > 1 && !(_vm.Account.PrimaryContact.IsEyeDoctor && index === 0)) ? _c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-font-size-17",
      on: {
        "click": function($event) {
          return _vm.RemoveDoctor(index)
        }
      }
    }, [_vm._v("Delete ")]) : _vm._e()]), _c('hr')])])
  }), _vm._v(" "), (_vm.Account.EyeDoctors.length > 1) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }) : _vm._e()], 2), _vm._v(" "), (!_vm.Account.NoEyeDoctor) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "evf-invite col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-8 offset-xs-0 center"
  }, [_c('button', {
    staticClass: "btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-main-blue--hover g-font-size-16 g-rounded-10 g-px-25 g-mb-10 g-mx-10",
    on: {
      "click": function($event) {
        return _vm.AddDoctor()
      }
    }
  }, [_vm._v("Add Another Doctor")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('small', [_vm._v("You will need to enter all the following information when placing an order")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3781fd82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3781fd82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/EyeDoctorInformation.vue
// module id = 500
// module chunks = 4